var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconChevronDownL(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    d: "M0 0h80v80H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 30.07a1 1 0 01.31-.72 1 1 0 011.41 0l18.33 19.22 18.22-19.28a1 1 0 011.42 0 1 1 0 010 1.41L40.78 50.71a1 1 0 01-1.45 0l-19-19.95a1 1 0 01-.33-.69z"
  })));
}

export default SvgIconChevronDownL;